import { Box } from '@material-ui/core';
import { Comment, formatDateTimeReadable } from '@nemuru-eng/js-api-client';
import React from 'react';

import { IconHeader } from '../../../../../../../shared/components/IconHeader';
import { getIconBySupportAgent } from '../../../../../utils/getIconBySupportAgent';
import { CommentChannelIcon } from './CommentChannelIcon';

interface SupportAgentInfoProps {
  comment: Comment;
}

export const SupportAgentInfo = ({ comment }: SupportAgentInfoProps) => {
  return (
    <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
      <IconHeader
        variant={'medium'}
        color={'secondary'}
        iconName={getIconBySupportAgent(comment.author.email)}
        labelComponent={<>{comment.author.name}</>}
        subLabelComponent={formatDateTimeReadable(new Date(comment.createdAt))}
      />
      <CommentChannelIcon comment={comment} />
    </Box>
  );
};
